import { FieldValues } from 'react-hook-form'
import { useMemo } from 'react'
import { NctsScope } from '../../../../shared/ncts/types'
import useNctsPhase from './useNctsPhase'
import useClientSideFieldRequirements from './useClientSideFieldRequirements'
import { DEFAULT_FIELD_RULE, FieldRule } from '../../models/fieldRules'
import { useDeclarationEditorContext, useServerRequirementsContext } from '../contexts/DeclarationEditorContext'

function useDeclarationFieldRequirements<TFieldValues extends FieldValues>(scope: NctsScope, paths: string[]) {
  const { phase, isOptIn } = useNctsPhase()
  const { editorData } = useDeclarationEditorContext()
  const { serverValidationResult } = useServerRequirementsContext(scope)

  const clientFieldRequirements = useClientSideFieldRequirements<TFieldValues>(paths, {
    scope,
    phase,
    isOptIn,
    editorData,
    serverValidationResult,
  })

  return useMemo(
    () => {
      const result: Record<string, FieldRule> = {}
      for (const path of paths) {
        result[path] = clientFieldRequirements[path] ?? DEFAULT_FIELD_RULE
      }

      return result
    },
    [paths, clientFieldRequirements],
  )
}

export default useDeclarationFieldRequirements
